'use client';

import { faCheck, faTimes } from '@fortawesome/pro-light-svg-icons';
import { useState } from 'react';

import { Button } from '@/components/ui/button/button.component';
import { Icon } from '@/components/ui/icon.component';
import { Sheet, SheetClose, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';

export function HowMedprevWorks() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button variant="text" onClick={() => setOpen(true)} className="w-auto text-green-500">
        <span className="font-semibold">Como funciona a Medprev</span>
      </Button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent
          side="centerFit"
          closingTagPosition="right"
          hasHeader={true}
          className="p-0 md:bg-transparent border-none overflow-x-hidden outline-none outline-offset-0 "
        >
          <div className="overflow-y-auto md:max-h-[60vh] max-h-[65vh]" data-testid="price-modal--search-modal">
            <SheetHeader className="bg-white">
              <div className="flex justify-between gap-[10px] p-6 px-5 pb-6 items-center">
                <div className="flex gap-[10px]">
                  <SheetTitle>
                    <span className="font-bold text-2xl text-gray-900">Como funciona a Medprev?</span>
                  </SheetTitle>
                </div>
                <SheetClose asChild className="text-gray-500 cursor-pointer self-center px-2 hover:bg-gray-50">
                  <Icon icon={faTimes} size="xl" className="hover:text-gray-900 text-[1.625rem]" />
                </SheetClose>
              </div>
            </SheetHeader>
            <div
              className="p-5 pt-0 bg-white text-gray-700 flex flex-col gap-6"
              data-testid="payment-methods-content--search-modal"
            >
              <p>
                Diferente de um plano de saúde, na Medprev você paga valores reduzidos por suas consultas e exames
                apenas quando usar os serviços, sem nenhum tipo de mensalidade ou taxas de adesão.
              </p>
              <p>
                Somos uma empresa paranaense com mais de 25 anos história, pioneira no acesso à saúde de forma ágil e
                descomplicada! Medprev, pague quando usar, use sempre que precisar!
              </p>
              <Button
                data-testid="close-button--how-medprev-works-modal"
                startIcon={faCheck}
                variant="default"
                onClick={() => setOpen(false)}
              >
                Entendi
              </Button>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
